const AuxComp = props => props.children;

export default AuxComp;
